import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '#pplx/frontend/aether/components/Icon/index.js';
import { createStackedVisuals } from '#pplx/frontend/apps/ask/shared-ui-components/createStackedVisuals.js';
import { SourceIcon } from '#pplx/frontend/apps/ask/sources/components/SourceIcon.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import React from 'react';
const SOURCES_MAX_VISUALS = 5;
export const SourcesMenuButtonContent = React.memo(function SourcesMenuButtonContent({ sources, size = 'default', maxVisuals = SOURCES_MAX_VISUALS, }) {
    if (sources.length > 0) {
        const icons = sources.map((source) => (_jsx(SourceIcon, { sourceId: source, size: size }, source)));
        return createStackedVisuals(icons, {
            isOverlapping: true,
            maxVisuals,
            size: 'md',
            stackDirection: 'right',
            overlappingClassName: 'overflow-hidden bg-base ring-soft',
        });
    }
    return _jsx(Icon, { icon: $icon('custom-perplexity-sources-active'), size: size });
});
//# sourceMappingURL=SourcesMenuButtonContent.js.map